import { Box } from '@mui/material';
import type { FieldMode } from '../../../hooks/useCaseField';
import { CaseTextField } from '../../fields';
import IcdCodesChips from './IcdCodesChips';

interface ClinicalSectionProps {
  mode: FieldMode;
  errors?: { [key: string]: string | undefined };
}

const ClinicalSection: React.FC<ClinicalSectionProps> = ({ mode, errors = {} }) => (
  <Box sx={{ mb: 2.5 }}>
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 140px', gap: 1.5, mb: 1.5, alignItems: 'start' }}>
      <IcdCodesChips mode={mode} error={errors.icdCodes} />
      <CaseTextField mode={mode} label="Level of Care"
        getValue={d => d.levelOfCare ?? ''} getUpdate={v => ({ levelOfCare: v })} />
    </Box>
  </Box>
);

export default ClinicalSection;